
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SocialTradingAllocationMethod enum
 */
class SocialTradingAllocationMethod {
  /**
   * Initialize enum with a given value
   * @param {SocialTradingAllocationMethod|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof SocialTradingAllocationMethod) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!SocialTradingAllocationMethod}
   * @param {!SocialTradingAllocationMethod} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingAllocationMethod)) {
      throw new TypeError('Instance of SocialTradingAllocationMethod is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!SocialTradingAllocationMethod}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!SocialTradingAllocationMethod}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === SocialTradingAllocationMethod.NONE.value) {
      return 'NONE'
    }
    if (this.value === SocialTradingAllocationMethod.EQUITY.value) {
      return 'EQUITY'
    }
    if (this.value === SocialTradingAllocationMethod.BALANCE.value) {
      return 'BALANCE'
    }
    if (this.value === SocialTradingAllocationMethod.LOT.value) {
      return 'LOT'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!SocialTradingAllocationMethod}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!SocialTradingAllocationMethod}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!SocialTradingAllocationMethod} Created enum
   */
  static fromObject (other) {
    return new SocialTradingAllocationMethod(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
SocialTradingAllocationMethod.NONE = new SocialTradingAllocationMethod(0 + 0)
// noinspection PointlessArithmeticExpressionJS
SocialTradingAllocationMethod.EQUITY = new SocialTradingAllocationMethod(1 + 0)
// noinspection PointlessArithmeticExpressionJS
SocialTradingAllocationMethod.BALANCE = new SocialTradingAllocationMethod(2 + 0)
// noinspection PointlessArithmeticExpressionJS
SocialTradingAllocationMethod.LOT = new SocialTradingAllocationMethod(3 + 0)

export { SocialTradingAllocationMethod };

/**
 * Fast Binary Encoding SocialTradingAllocationMethod field model
 */
class FieldModelSocialTradingAllocationMethod extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelSocialTradingAllocationMethod}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelSocialTradingAllocationMethod}
   * @param {SocialTradingAllocationMethod=} defaults Default value, defaults is new SocialTradingAllocationMethod()
   * @returns {!SocialTradingAllocationMethod} Result value
   */
  get (defaults = new SocialTradingAllocationMethod()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new SocialTradingAllocationMethod(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelSocialTradingAllocationMethod}
   * @param {!SocialTradingAllocationMethod} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelSocialTradingAllocationMethod };
